import {
  GetSupplierProductByMainNo,
  GetProductInfoByTracNo,
  SendUdiResolverConfirm
} from '@/api'
 
export default {
  name: 'ScanMixin',
  data () {
    return {
      // 扫码框焦点
      scanInputIsfocus: false,
      // 是否扫码界面
      showCode: false,
      // 扫码次数
      count: 0,
      // 扫到的码
      code: '',
      // 上次时间
      lastTime: 0,
 
      tableCode: '',

      originalData:[],
      options: [],
      selectedOptions: 0,
      isMultipleResults: false,
      checkboxRadioStates:[]
    }
  },
  mounted () {
    this.tableCode = this.$route.name.replace('Edit', '')
 
    window.addEventListener("keypress", this.init, true)
  },
  destroyed () {
    window.removeEventListener("keypress", this.init, true)
  },
 
  methods: {
    // 扫码相关
    init (e) {
      var currCode = e.which;
      var currTime = new Date().getTime();
      if (this.lastTime > 0) {
        if (currTime - this.lastTime <= 100) {
          // this.code += String.fromCharCode(currCode);
        } else {
          // if (currTime - this.lastTime > 1000) {
          // 超时清空
          this.clearCode();
        }
        this.code += String.fromCharCode(currCode);
      }
      // 第一次按键
      else {
        this.code = String.fromCharCode(currCode);
      }
      this.lastTime = currTime;
      // 遇到回车
      if (currCode == 13 && this.isScan && !this.scanInputIsfocus) {
        // alert(code); // 这里得到码，做下一步业务处理
        this.mainNoChange(this.code)
        // console.log("123456789")
        // 回车输入后清空
        this.clearCode();
      }
    },
    clearCode () {
      this.code = '';
      this.lastTime = 0;
    },
    mainNoChange (val, num) {
 
      // 去掉空格
      val = val.replace(/\s+/g, "").toUpperCase()
      if (!val || val == '') {
        return;
      }
 
      if (this.count === 0) {
        if (this.childForm.mainNo && this.childForm.traceNo) {
          let valid = this.pushChildForm(false)
          if (!valid) {
            this.code = '';
            this.childForm.no = ''
            return
          }
        }
        this.getSupplierProductByMainno(val, num)
      }
      else {
        if (val == this.childForm.mainNo) {
          this.$my_message('主码和追溯码不能相同', 'warning')
          return
        }
        var traceNo = val
        if (this.childForm.mainNo) {
          traceNo = val.startsWith(this.childForm.mainNo) ? val.substr(this.childForm.mainNo.length, val.length - this.childForm.mainNo.length) : val
        }
        this.getSupplierByTraceNo(traceNo)
      }
    },
    getSupplierProductByMainno (no, num) {
      var isEnabledStr = num == 1 ? num : '0'
      var reg = RegExp(`^${this.childForm.mainNo}`)
      if (no == this.childForm.mainNo || (reg.exec(no) && this.childForm.mainNo && this.childForm.mainNo != '')) {
        this.count++
        this.childForm.no = ''
        return;
      }
      this.resetDetailFormData()
      GetSupplierProductByMainNo({ mainNo: no, isEnabledStr: isEnabledStr })
        .then(res => {
          if (!res.successful) {
            return
          }
 
          if ((this.tableCode == "PurchaseDistribution" || this.tableCode == "StockUpCheck" || this.tableCode == "SurgicalCheck") && res.returnData.isEnabled != 1) {
            this.$my_message(`产品名称 [${res.returnData.productName}] 规格型号 [${res.returnData.specName}] 已被禁用，请核对后再验收`, 'warning') //
            return;
          }
 
          // this.childForm = this.mapper.SupplierProduct2Form(this.childForm, res.returnData)
          let id = this.childForm.id
          this.childForm = Object.assign(this.childForm, res.returnData)
          this.childForm.orgCode = sessionStorage.getItem('orgId')
          this.childForm.id = id
          this.childForm.remark = ''
          this.childForm.supplierProductId = res.returnData.id
          this.childForm.supplierProductNo = res.returnData.no
          this.childForm.packNumber = res.returnData.packNumber?res.returnData.packNumber:0
          // this.childForm.number = 1
          this.childForm.price = this.childForm.purchasePrice
          // this.childForm.amount = this.childForm.price
          this.childForm.no = ''
          this.childForm.mainNo = this.childForm.countryNo
 
          this.childForm.number = 1
          this.childForm.unUseNumber = 1
          if (this.tableCode == 'CollectInStock') {
            this.childForm.price = res.returnData.billingPrice
            this.childForm.purchasePrice = res.returnData.purchasePrice
            this.childForm.purchaseAmount = res.returnData.purchasePrice
          }
 
          this.getProductRegistCertDetails(this.childForm.productId);
 
          this.childForm.amount = this.childForm.number * this.childForm.price
          this.count++
          this.childForm.no = ''
          this.$forceUpdate()
        })
    },
    getSupplierByTraceNo (no) {
      if (this.childForm.traceNo == no && this.childForm.number > 0) {
        this.childForm.number = this.childForm.number * 1 + 1
        this.childForm.unUseNumber = this.childForm.number
        this.childForm.amount = this.childForm.number * this.childForm.price
        this.count--
        this.childForm.no = ''
        return;
      }
 
      //添加行
      let arr = this.form.details.filter(item => item.mainNo == this.childForm.mainNo && item.traceNo == no)
      this.childForm.traceNo = no
 
      // 添加行记录
      if (arr.length > 0) {
        // 存在则把列表的数据拿过来，并且数量加1
        this.editChildren = true
        this.form.details = this.form.details.map(item => {
          if (item.mainNo == this.childForm.mainNo && item.traceNo == no) {
            this.childForm.packSpec = item.packSpec
            this.childForm.locationId = item.locationId
            this.childForm.locationName = item.locationName
            this.childForm.manufactureDate = item.manufactureDate
            this.childForm.batch = item.batch
            this.childForm.validityDate = item.validityDate
            this.childForm.serialNo = item.serialNo
            this.childForm.remark = item.remark
            this.childForm.number = item.number * 1 + 1
            this.childForm.unUseNumber = this.childForm.number
            this.childForm.price = item.price
            this.childForm.billingPrice = item.billingPrice
            this.childForm.purchasePrice = item.purchasePrice
            this.childForm.amount = this.childForm.number * this.childForm.price
            this.childForm.purchaseAmount = this.childForm.number * this.childForm.purchasePrice
            this.childForm.orgCode = sessionStorage.getItem('orgId')
          }
          return item
        })
 
        this.count--
        this.childForm.no = ''
      } else {
        // 不存在则调用扫码解析，解析成功添加行记录
        GetProductInfoByTracNo({ traceNo: no, mainNo: this.childForm.mainNo })
          .then(res => {
            if (!res.successful) {
              return
            }
            this.originalData = res.returnData 
            this.options = JSON.parse(JSON.stringify(this.originalData))
            this.options.push({ NoMorePrompts: true })
            this.showConfirmDialog()
          })
      }
    },
 

   async childFormAssignment () {
      let data = this.originalData[this.selectedOptions]
      this.count--;
      this.childForm.no = "";
      this.childForm.$index = this.form.details.length + 1;
      this.childForm.manufactureDate = data.manufactureDate;
      this.childForm.batch = data.batch;
      this.childForm.validityDate = data.validityDate;
      this.childForm.serialNo = data.serialNo;
      this.childForm.number = 1;
      this.childForm.unUseNumber = this.childForm.number;
      this.childForm.amount = this.childForm.number * this.childForm.price;
      this.childForm.purchaseAmount =
      this.childForm.number * this.childForm.purchasePrice;
      this.childForm.orgCode = sessionStorage.getItem('orgId')
      this.selectedOptions = 0
      if( this.originalData.length>1){
       await SendUdiResolverConfirm({
          mainNo: this.childForm.mainNo,
          traceNo: this.childForm.traceNo,
          batchLength:this.childForm.batch?this.childForm.batch.length:0,
          serialNoLength:this.childForm.serialNo?this.childForm.serialNo.length:0,
          count:1
        })
      }
      this.$forceUpdate();
    },

    // 处理渲染
    createCheckbox (option) {
      const isCheckbox = option.index == this.options.length-1; 
      return this.$createElement('div', { class: 'custom-span' }, [
        this.$createElement('input', {
          attrs: {
            type: isCheckbox ? 'checkbox' : 'radio',  // 判断是复选框还是单选框
            class: 'custom-checkbox',
            name: isCheckbox ? `checkbox_${option.index}` : 'radio_group', // 每个复选框使用不同的name, 单选框共享 name
            checked: option.checked || false
          },
          on: {
            change: (event) =>{
              this.checkboxRadioStates[option.index] = event.target.checked;
                    option.checked = event.target.checked;

              this.handleCheckboxChange(event, option.index)
            }
          }
        }),
        this.$createElement('span', option.name)
      ]);
    },



    showConfirmDialog () {
      if (this.isMultipleResults||this.options.length == 2) {
        this.childFormAssignment()
      } else {        
        const messageVNode = this.$createElement('div', {key: Date.now()}, [
          this.$createElement('p', `追溯码解码结果存在多个，请选择正确的结果`),
  
          this.$createElement('div', { class: 'checkbox-container' },
  
  
            this.options.map((item, index) => {
              let obj = {}
              // 生成字段的拼接
              let nameParts = [];
              if (item.batch) {
                nameParts.push(`批次号 ${item.batch}`);
              }
              if (item.serialNo) {
                nameParts.push(`序列号 ${item.serialNo}`);
              }
              if (item.manufactureDate) {
                nameParts.push(`生产日期 ${item.manufactureDate}`);
              }
              if (item.validityDate) {
                nameParts.push(`失效日期 ${item.validityDate}`);
              }
             
              if(index==0){
                obj.checked = true
              }else{
                obj.checked = false
              }
              if (item.NoMorePrompts) {
                nameParts.push(`下次不再弹窗提醒`);
                obj.checked = true
                this.isMultipleResults = true; 
              }
              // 将拼接的部分以中文逗号分隔
              obj.name = nameParts.join('，');
              obj.index = index
              
              return this.createCheckbox(obj)
            })
          
          )
        ]);
        
          this.$msgbox({
            title: '提示',
            message: messageVNode,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.options = []
            this.childFormAssignment()
            
            // 重置选中状态数组
            this.checkboxRadioStates = [];
          }).catch(() => {
            this.isMultipleResults = false;
            this.selectedOptions = '';
            this.options = [];
            // 同样重置选中状态数组
            this.checkboxRadioStates = [];
          });
      }
    },
    handleCheckboxChange (event, index) {
      if (index == this.options.length-1) {
        this.isMultipleResults = event.target.checked
        // this.selectedOptions = 0
      } else {
        this.selectedOptions = index
      }
      // // this.selectedOptions[index] = event.target.checked;
    },
    scanInputFocus () {
      this.scanInputIsfocus = true
    },
    scanInputBlur () {
      this.scanInputIsfocus = false
    },
  }
}